export default function EmailSetting() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Email Setting
            </div>
            <div className="page-sub" id="page-sub">
              System › Email SMTP Configuration
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="two-col">
            <div className="card">
              <div className="flex-between mb12">
                <div className="card-title" style={{ margin: 0 }}>
                  SMTP Configurations
                </div>
                <button
                  className="btn btn-primary btn-sm"
                  onclick="openSmtpModal(null)"
                >
                  + Add SMTP
                </button>
              </div>
              <div className="info-box mb12">
                Add multiple SMTP configs. Only one can be active at a time — it
                will be used for all outgoing emails.
              </div>
              <div
                style={{
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: "14px 16px",
                  marginBottom: 12,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <div
                    className="cus-grid-053"
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <label className="toggle">
                      <input
                        type="checkbox"
                        defaultChecked=""
                        onchange="toggleSmtp(0,this.checked)"
                      />
                      <span className="toggle-slider" />
                    </label>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700 }}>
                        Gmail SMTP
                      </div>
                      <div
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        smtp.gmail.com:587
                      </div>
                    </div>
                    <span
                      className="badge badge-active"
                      style={{ fontSize: 10 }}
                    >
                      Active
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button
                      className="btn btn-xs"
                      onclick="sendTestEmailFrom(0)"
                    >
                      📧 Test
                    </button>
                    <button className="btn btn-xs" onclick="openSmtpModal(0)">
                      ✎ Edit
                    </button>
                    <button
                      className="btn btn-xs btn-danger"
                      onclick="deleteSmtp(0)"
                    >
                      🗑
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 6,
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  <span>👤 noreply@nestmanager.in</span>
                  <span>🔒 TLS</span>
                  <span>📛 From: NestManager Platform</span>
                  <span>📧 noreply@nestmanager.in</span>
                </div>
              </div>
              <div
                style={{
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: "14px 16px",
                  marginBottom: 12,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <label className="toggle">
                      <input
                        type="checkbox"
                        onchange="toggleSmtp(1,this.checked)"
                      />
                      <span className="toggle-slider" />
                    </label>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700 }}>
                        SendGrid
                      </div>
                      <div
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        smtp.sendgrid.net:465
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button
                      className="btn btn-xs"
                      onclick="sendTestEmailFrom(1)"
                    >
                      📧 Test
                    </button>
                    <button className="btn btn-xs" onclick="openSmtpModal(1)">
                      ✎ Edit
                    </button>
                    <button
                      className="btn btn-xs btn-danger"
                      onclick="deleteSmtp(1)"
                    >
                      🗑
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 6,
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  <span>👤 apikey</span>
                  <span>🔒 SSL</span>
                  <span>📛 From: NestManager</span>
                  <span>📧 info@nestmanager.in</span>
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <button className="btn" onclick="sendTestEmail()">
                  📧 Send Test Email
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-title">Email Templates</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    Welcome Email
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Sent on new user registration
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-xs" onclick="previewEmailTpl(0)">
                    Preview
                  </button>
                  <button
                    className="btn btn-xs btn-primary"
                    onclick="editEmailTpl(0)"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    Rent Invoice
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Monthly bill with PDF attachment
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-xs" onclick="previewEmailTpl(1)">
                    Preview
                  </button>
                  <button
                    className="btn btn-xs btn-primary"
                    onclick="editEmailTpl(1)"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    Payment Receipt
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Sent after payment confirmation
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-xs" onclick="previewEmailTpl(2)">
                    Preview
                  </button>
                  <button
                    className="btn btn-xs btn-primary"
                    onclick="editEmailTpl(2)"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    Password Reset
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    OTP-based reset link
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-xs" onclick="previewEmailTpl(3)">
                    Preview
                  </button>
                  <button
                    className="btn btn-xs btn-primary"
                    onclick="editEmailTpl(3)"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    Subscription Expiry
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    7-day advance renewal reminder
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-xs" onclick="previewEmailTpl(4)">
                    Preview
                  </button>
                  <button
                    className="btn btn-xs btn-primary"
                    onclick="editEmailTpl(4)"
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
